import "./index.scss";

const SupplierSecondSection = ({ data }) => {
  const { title, subTitle, list, mainImage, backgroundColor } = data;
  return (
    <div
      className="supplier-second-section-sontainer"
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <div className="supplier-second-section">
        <p className="supplier-second-section-title">{title}</p>
        <p className="supplier-second-section-subtitle">{subTitle}</p>
        <div className="supplier-second-section-row">
          <img
            className="supplier-second-section-left"
            alt={title}
            src={mainImage}
          />
          <div className="supplier-second-section-right">
            {list?.map((item) => {
              return (
                <div className="supplier-second-section-right-row">
                  <img
                    className="supplier-second-section-right-icon"
                    src={item?.icon}
                    alt={item.title}
                  />
                  <div className="supplier-second-section-right-row-items">
                    <div className="supplier-second-section-row-item-title">
                      {item?.title}
                    </div>
                    <div
                      className="supplier-second-section-row-item-sub-title"
                      dangerouslySetInnerHTML={{
                        __html: item?.subTitle.replace(/\n/g, "<br>"),
                      }}
                    />

                    {/* <div className="supplier-second-section-row-item-sub-title">
                      {item?.subTitle}
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierSecondSection;
